import { LIB_VERSION } from '../../version';
import { getWebInitTimestamp, getVmokGlobalProps } from './util';
const registerMeta = {
    start: 0,
    end: 0,
};
export function setRegisterStart() {
    registerMeta.start = Date.now();
}
export function setRegisterEnd() {
    registerMeta.end = Date.now();
}
export function sendCommonInfoEvent(slardarClient) {
    const { vmok } = slardarClient.getState();
    const metrics = {};
    metrics.registerDuration = registerMeta.end - registerMeta.start;
    metrics.navigationStartTime = getWebInitTimestamp();
    if (window.TTAP_DOMPARSE_STARTTIME) {
        metrics.domParseStart = window.TTAP_DOMPARSE_STARTTIME - metrics.navigationStartTime;
    }
    if (window.TTAP_APPPARSE_STARTTIME) {
        metrics.appParseStart = window.TTAP_APPPARSE_STARTTIME - metrics.navigationStartTime;
    }
    if (vmok) {
        const name = vmok.name;
        const vmokReadyToLoadTime = getVmokGlobalProps(name, 'afterResolve');
        const vmokLoadedTime = getVmokGlobalProps(name, 'onLoad');
        if (vmokReadyToLoadTime && vmokLoadedTime) {
            metrics.vmokReadyToLoad = vmokReadyToLoadTime - metrics.navigationStartTime;
            metrics.vmokLoaded = vmokLoadedTime - metrics.navigationStartTime;
        }
    }
    const categories = {};
    const version = LIB_VERSION;
    if (version) {
        categories.version = version;
    }
    slardarClient.callClient('sendEvent', {
        name: 'ttapplugin_info',
        metrics,
        categories,
    });
}
//# sourceMappingURL=commonMetric.js.map